import { VICTRON_BASE_URL } from '@constants/common';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const tagTypes = ['Blog Posts', 'Blog Categories', 'Blog Subscription'];

const needsVictronWordpressCredentials =
    VICTRON_BASE_URL.includes('acceptance') || VICTRON_BASE_URL.includes('internal');

const headers = needsVictronWordpressCredentials ? { Authorization: 'Basic ' + btoa('victron:victron') } : undefined;

const baseQuery = fetchBaseQuery({
    baseUrl: `${VICTRON_BASE_URL}/blog`,
    headers,
});

export const wordpressApi = createApi({
    baseQuery,
    tagTypes,
    endpoints: () => ({}),
    reducerPath: 'wordpress_api',
});
